import { render, staticRenderFns } from "./new-contract.vue?vue&type=template&id=0a7d49ea&scoped=true&"
import script from "./new-contract.vue?vue&type=script&lang=js&"
export * from "./new-contract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d49ea",
  null
  
)

export default component.exports